import { call, put } from "redux-saga/effects";
import { routes } from "../../common/api/routes";
import { setCareersError, setCareersSuccess, getResultsSuccess } from "../actions";

export function* setCareersSaga({ payload }) {
    try {
        const isUnsave = payload.interested === false;

        const response = yield call(
            isUnsave ? routes.unsetCareers : routes.setCareers,
            isUnsave
                ? { id: payload.interestedId, interested: false }
                : { career_key: payload.career_key, interested: true }
        );

        yield put(
            setCareersSuccess({
                career_key: payload.career_key,
                interested: isUnsave
                    ? { added: false, id: null }             // ← on unsave, explicitly reset id to null
                    : {
                        added: true,
                        id: response.result?.interested?.id  // ← on save, store the new record id
                            ?? response.result?.id             // ← fallback if API returns id at top level
                            ?? null,
                    },

            })
        );

        const resultsResponse = yield call(routes.getResults, {});
        yield put(getResultsSuccess(resultsResponse));

    } catch (error) {
        yield put(
            setCareersError({
                career_key: payload.career_key,
                error,
            })
        );
    }
}